import { FC } from 'react';
import { WidgetType } from 'types/widget.types';
import { MultiLineWidgetToolbar } from 'widgets/LineWidget/toolbar/MultiLineWidgetToolbar';

// Map of widget types to their toolbar components
// If all selected widgets have the same type, and is defined here, this toolbar component will be shown
// Add more widgets here if they require a separate toolbar component when multi selected
export const CUSTOM_WIDGET_TOOLBAR_MAP: { [key in WidgetType]?: FC } = {
  [WidgetType.Line]: MultiLineWidgetToolbar,
};
